module.exports = __webpack_public_path__ + "assets/img/contact_big_en.13f0319e.png";